import { clearWorld, createGameWorld } from 'shared/src/ecs/world';
import {
  createCollisionSystem,
  createGravitySystem,
  createMovementSystem,
  createPathTrackerSystem,
  createPolarJetSystem,
} from 'shared/src/ecs/systems';
import { createRenderObservers, createRenderSystem } from 'src/render/renderSystem';
import { EntityRenderManager, FxManager } from 'src/render/managers';
import { gameBus, GameEvents } from 'src/events';
import { getSoundManager } from './resourceScene';
import { drawPathListener } from 'src/util/debug';
import { AppScenes } from '../types';
import * as sysComponents from 'shared/src/ecs/components';
import * as renderComponents from 'src/render/components';

// Basic scaffolding to run a game, or use game objects
export class BaseScene extends Phaser.Scene {
  public world = createGameWorld([...Object.values(sysComponents), ...Object.values(renderComponents)]);
  public debug = false;
  public fxManager = new FxManager(this);

  protected renderManager = new EntityRenderManager(this);
  protected unsubRenderObservers = () => {};
  protected movementSystem = createMovementSystem();
  protected pathTrackerSystem = createPathTrackerSystem();
  protected gravitySystem = createGravitySystem();
  protected polarJetSystem = createPolarJetSystem();
  protected collisionSystem = createCollisionSystem();
  protected renderSystem = createRenderSystem(this, this.renderManager);

  constructor(sceneKey: AppScenes) {
    super({ key: sceneKey, active: false });
    this.world.debug = this.debug;
  }

  create() {
    this.unsubRenderObservers = createRenderObservers(this.world, this.renderManager);
    drawPathListener(this);
    this.fxManager.create();
    // For some reason, shaders in fxManager need a moment to load
    // Without the timeout, setting shader uniforms throws
    setTimeout(() => {
      this.fxManager.activate();
    }, 10)
  }

  update(time: number, deltaMs: number) {
    this.world.time = time;
    this.world.delta = deltaMs;
    this.movementSystem(this.world);
    this.pathTrackerSystem(this.world);
    this.gravitySystem(this.world);
    this.polarJetSystem(this.world);
    this.collisionSystem(this.world);
    this.renderSystem(this.world);
    this.fxManager.update();
  }

  destroy() {
    getSoundManager(this).stopAllSounds('effects');
    clearWorld(this.world);
    // this.world = createGameWorld();
    this.unsubRenderObservers();
    this.fxManager.destroy();
    this.renderManager.destroy();
    gameBus.off(GameEvents.START_GAME);
    gameBus.off(GameEvents.DEBUG_DRAW_PATH);
    gameBus.emit(GameEvents.SCENE_UNLOADED, this.scene.key as AppScenes)
  }
}
